module.exports = __webpack_public_path__ + "img/front.bdce4701.jpg";